export class MonthPelletizingProductionQuality {
  constructor({
        id= null, 
        code='',
        month= ``,
        monthStr='',
        locName= ``,          
        productName= ``,
        itemName='',
    } = {}) {
    this.id = id;
    this.code=code;
    this.month = month;
    this.monthStr=monthStr;
    this.locName = locName;      
    this.productName = productName;
    this.itemName = itemName;
  }
}
export function gridFields() {
  return Object.freeze([         
    {
      key: 'code',
      label: 'lbl.basic.code',
      sortable: true,
      form: {
        type: 'input'
      }
    }, 
      {
        key: 'locName',
        label: 'lbl.basic.locName',
        sortable: true,
        form: {
          type: 'input'
        }
      }, 
      {
        key: 'monthStr',
        label: 'lbl.basic.month',
        sortable: true,
        form: {
          type: 'input'
        }
      },                        
      {
        key: 'productName',
        label: 'lbl.prd.execution.productionName',
        sortable: false,
        form: {
          type: 'input'
        }
      }, 
      {
        key: 'itemName',
        label: 'lbl.prd.execution.itemName',
        sortable: false,
        form: {
          type: 'input'
        }
      },
  ]);
}
export const fields = Object.freeze(Object.keys(new MonthPelletizingProductionQuality()).map(i => 'entity.' + i));
export const filterFields = [
  'filter.locNameFilter',
  'filter.startDayFilter',
  'filter.endDayFilter', 
];
export const filter = {
  'locNameFilter': "",    
    'startDayFilter': "",
    'endDayFilter': "",
};